import { Modal } from '@mui/material'
import { InputField } from 'cwp-components/forms/'
import React, { useEffect, useState } from 'react'
import { Checkmark } from '../../icons'
import { useForm } from 'react-hook-form'
import { CheckboxGroup } from '../../../../common/components/Inputs/CheckboxGroup'
import { useNavigate } from 'react-router-dom'

const Newsletter = ({ open, closeModal }) => {
  const [showSuccess, setShowSuccess] = useState<boolean>(false)
  const [firstPage, setFirstPage] = useState<boolean>(true)
  const navigate = useNavigate()

  const {
    register,
    reset,
    handleSubmit,
    formState: { errors },
  } = useForm({
    mode: 'onBlur',
    reValidateMode: 'onChange',
  })

  const onSubmit = async (data) => {
    const res = await fetch(
      'https://staging.api.legalutopia.co.uk/api/v1/website/subscribe-newsletter/',
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          'first_name': data.firstName,
          'last_name': data.lastName,
          'email': data.emailAddress,
        }),
      },
    )
    console.log('submit')
    if (!res.ok) {
      console.error('Failed to submit newsletter')
      setShowSuccess(false)
      setFirstPage(false)
    } else {
      console.error('Submitted the newsletter')
      setShowSuccess(true)
      setFirstPage(false)
    }
  }

  const [isChecked, setIsChecked] = useState<boolean>(false)

  const handleChange = () => setIsChecked(!isChecked)

  const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
  const alphaPattern = /^[A-Za-z]+$/

  const closePopup = () => {
    setShowSuccess(false)
    setFirstPage(true)
    setIsChecked(false)
    reset()
    closeModal()
  }

  useEffect(() => {
    if (!firstPage && !showSuccess) {
      closeModal()
      navigate('/error')
    }
  }, [firstPage, showSuccess])

  if (!firstPage && showSuccess) {
    return (
      <Modal
        className=' !bg-[rgba(234, 236, 240, 0.50)] backdrop-blur-[12.5px]'
        open={open}
        onClose={() => closeModal()}
      >
        <div className='modal-dialog'>
          <div className='w-100'>
            <div className='flex justify-end'>
              <button onClick={closePopup}>
                <Checkmark />
              </button>
            </div>
          </div>
          <div className='modal-content px-5 py-2 flex flex-col justify-center items-center'>
            <h1
              className='text-[#003831] font-bold leading-normal text-center'
              style={{ fontSize: '24px', letterSpacing: '0.4px' }}
            >
              Thank you!
            </h1>
            <span className='text-[16px] font-[400] mt-1'>
              We have received your email.
            </span>
          </div>
        </div>
      </Modal>
    )
  }

  return (
    <Modal
      className=' !bg-[rgba(234, 236, 240, 0.50)] backdrop-blur-[12.5px]'
      open={open}
      onClose={() => closeModal()}
    >
      {firstPage && !showSuccess ? (
        <div className='modal-dialog'>
          <div className='w-100'>
            <div className='flex justify-end'>
              <button onClick={closePopup}>
                <Checkmark />
              </button>
            </div>
          </div>
          <div className='modal-content px-5 '>
            <h1 className='text-2xl font-bold leading-tight tracking-wide text-center text-[#003830] whitespace-pre-line'>
              {`Stay updated with 
                our latest news`}
            </h1>
            <form
              onSubmit={handleSubmit(onSubmit)}
              className='w-full flex flex-col justify-center item-center mt-[26px]'
            >
              <div className='mx-auto'>
                <InputField
                  register={register}
                  required={true}
                  regexPattern={alphaPattern}
                  id='firstName'
                  label='First name'
                  placeholder='firstName'
                  className='w-[300px] sm:w-[500px] h-[52px] mb-3'
                  errors={errors}
                  errorMessage='Please enter your first name'
                  biggerInput
                />
              </div>
              <div className='mx-auto'>
                <InputField
                  register={register}
                  required={true}
                  regexPattern={alphaPattern}
                  id='lastName'
                  label='Last name'
                  placeholder='lastName'
                  className='w-[300px] sm:w-[500px] h-[52px] mb-5'
                  errors={errors}
                  errorMessage='Please enter your last name'
                  biggerInput
                />
              </div>
              <div className='mx-auto'>
                <InputField
                  register={register}
                  required={true}
                  regexPattern={emailPattern}
                  id='emailAddress'
                  label='Email Address'
                  placeholder='emailAddress'
                  className='w-[300px] sm:w-[500px] h-[52px] mb-5'
                  errors={errors}
                  errorMessage='Please enter your email address'
                  biggerInput
                />
              </div>
              <div className='flex justify-start pt-3 border-t-[1px] border-t-[#CCE0DD]'>
                <CheckboxGroup
                  id='terms'
                  onChange={handleChange}
                  checked={isChecked}
                  label={
                    <span className='text-sm font-medium'>
                      I agree to the
                      <a
                        href='https://www.legalutopia.co.uk/privacy-policy-web'
                        className='text-[#001a3d] hover:text-[#6596d7] active:text-[#1f5497] disabled:text-[#a0abbe] underline inline-block px-1'
                      >
                        Privacy policy
                      </a>
                      and
                      <a
                        href='https://www.legalutopia.co.uk/marketing-policy'
                        className='text-[#001a3d] hover:text-[#6596d7] active:text-[#1f5497] disabled:text-[#a0abbe] underline inline-block px-1'
                      >
                        Marketing policy
                      </a>
                    </span>
                  }
                  name='terms'
                />
              </div>

              <div className='flex justify-end pt-[26px]'>
                <button
                  className={`p-1 px-[10px] rounded-md text-base font-medium tracking-wider cursor-pointer
                    bg-[#020250] shadow-[0_1px_4px_0_rgba(0,0,0,0.25)] text-white 
                    hover:text-[#65C2D7] 
                    active:text-white 
                    disabled:text-[#a0abbe] disabled:bg-[#f4f4f4] disabled:cursor-not-allowed  
                  `}
                  disabled={!isChecked}
                >
                  Send
                </button>
              </div>
            </form>
          </div>
        </div>
      ) : (
        <></>
      )}
    </Modal>
  )
}

export default Newsletter
